<template>
  <el-container class="use-background">
    <el-header>
      <img :src="image_brand" class="image-brand" />
      <span class="header-right">
        <el-button round size="small" @click="goto('login')">Login</el-button>
        <el-button round size="small" @click="goto('register')">Register</el-button>
      </span>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      image_brand: require('../assets/logo-putih.png'),
    }
  },
  methods: {
    goto: function(name) {
      this.$router.push({name: name})
    }
  }
}
</script>